import { CommonModule } from '@angular/common';
import { Component, HostListener, input, output } from '@angular/core';
import { IconSvgComponent, RxButtonModule } from '@roomex/rx-components';

@Component({
  standalone: true,
  selector: 'rx-applications-dialog-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss'],
  imports: [CommonModule, RxButtonModule, IconSvgComponent],
})
export class DialogModalComponent {
  title = input.required<string>();
  message = input.required<string>();
  cancelText = input.required<string>();
  confirmText = input.required<string>();
  testIdPrefix = input<string>('test-dialog-modal');

  confirm = output();
  cancel = output();

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.cancel.emit();
  }
}
